import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Back one screen — not back to the top.
 *
 *  A hard link to the dashboard turns A>B>C>D into D>A. This steps back
 *  through the browser's own history and only uses `to` when there is nothing
 *  to step back to (page opened directly, or refreshed).
 */
export const BackLink = ({ to = "/academy", label = "Back",
                           className = "", testId = "back-link" }) => {
  const navigate = useNavigate();
  const go = () => {
    const idx = window.history.state?.idx;
    if (typeof idx === "number" && idx > 0) navigate(-1);
    else navigate(to);
  };
  return (
    <Button variant="ghost" size="sm" onClick={go} data-testid={testId}
      className={`min-h-[44px] ${className}`}>
      <ArrowLeft className="w-4 h-4 mr-1.5" /> {label}
    </Button>
  );
};

export default BackLink;
